import { Outlet, Link } from "react-router-dom";
import {
  Typography,
  AppBar,
  CssBaseline,
  Toolbar,
  Container,
  Box,
} from "@mui/material";
import { StyledEngineProvider } from "@mui/material/styles";
import { ReactComponent as LogoSvg } from "../images/sst_logo.svg";
import "../css/header.css";

export default function Header() {
  return (
    <StyledEngineProvider injectFirst>
      <>
        <CssBaseline />
        <AppBar className="app-bar" position="relative" color="primary">
          <Toolbar className="tool-bar">
            <LogoSvg className="logo"></LogoSvg>

            <Typography className="mainostoimisto" variant="h4">
              Mainostoimisto SST
            </Typography>

            <Typography className="digisovellukset" variant="h7">
              Digisovellukset
            </Typography>
          </Toolbar>
        </AppBar>
        <Container maxWidth="md">
          <Typography
            className="header-text"
            variant="h1"
            align="center"
            gutterBottom
          >
            Digikampanjat
          </Typography>
          <Typography
            className="header-p"
            variant="h5"
            align="center"
            paragraph
          >
            Mainostoimisto SST Oy
          </Typography>
        </Container>
      </>
    </StyledEngineProvider>
  );
}
